import { exists } from '@/api'

export interface AuthUserGroup {
  id: number
  name: string
  lending: number
  return: number
  bibliography: number
  user: number
  reference: number
  revision: number
}

export const defaultAuthUserGroup = (): AuthUserGroup => ({
  id: 0,
  name: '',
  lending: 0,
  return: 0,
  bibliography: 0,
  user: 0,
  reference: 0,
  revision: 0
})

export function AuthUserGroupFromJSON(json: any): AuthUserGroup {
  return {
    id: exists(json, 'id') ? json.id : 0,
    name: exists(json, 'name') ? json.name : '',
    lending: exists(json, 'lending') ? json.lending : 0,
    return: exists(json, 'return') ? json.return : 0,
    bibliography: exists(json, 'bibliography') ? json.bibliography : 0,
    user: exists(json, 'user') ? json.user : 0,
    reference: exists(json, 'reference') ? json.reference : 0,
    revision: exists(json, 'revision') ? json.revision : 0
  }
}
